<template>
  <div>
    <div class="float-right">
      <!--
        was `ui-sref='router-diagnostics'`. ui-router directives cannot live in a Vue template, so
        the navigation is emitted and FooterCtrl does the $state.go (the profile pattern).
      -->
      <a
        v-if="isAdmin"
        id="diagnosticsLink"
        class="text-muted"
        style="margin-right: 10px; text-decoration: none"
        href="/diagnostics"
        v-on:click.prevent="$emit('go-to-diagnostics')"
        >Diagnostics</a
      >
      <img :src="logo" height="25px" />
    </div>
    <div>
      <span>v2023 {{ version.version }} - {{ version.hostname }} - {{ timezone }}</span>
    </div>
  </div>
</template>

<script>
// webpack rewrites this import; a `require()` inside a template expression would not be resolved.
import logo from '../../web/images/resourceful-logo.png'

export default {
  name: 'FooterComponent',
  props: {
    // `{ version, hostname }` from GET /version (FooterService), or {} until it lands.
    version: {
      type: Object,
      default: () => ({}),
    },
    timezone: {
      type: String,
      default: '',
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { logo }
  },
}
</script>
